import {
  useCheckIsExtractedTextCSVEmptyQuery,
  useLazyGetExtractedTextCSVQuery,
} from '@carboncopyco/data';
import { useFileServiceContext } from '../../store/context/FileServiceContext';

export const useDownloadExtractedText = ({
  cloneId,
  cloneRevisionId,
  organizationId,
}: {
  cloneId?: string | number;
  cloneRevisionId?: number;
  organizationId?: string;
}) => {
  const { downloadFileFromUrl } = useFileServiceContext();
  const [getFileUrl] = useLazyGetExtractedTextCSVQuery();

  const { data } = useCheckIsExtractedTextCSVEmptyQuery(
    {
      organizationId: organizationId || '',
      entityId: String(cloneId),
      entityType: 'record',
      revisionId: String(cloneRevisionId),
    },
    {
      skip:
        !organizationId ||
        cloneId === undefined ||
        cloneRevisionId === undefined,
    }
  );

  const isCSVEmpty = data?.isEmpty;

  const downloadExtractedText = async () => {
    if (
      cloneId === undefined ||
      cloneRevisionId === undefined ||
      !organizationId
    ) {
      return;
    }

    const url = await getFileUrl({
      organizationId: organizationId,
      entityId: String(cloneId),
      entityType: 'record',
      revisionId: String(cloneRevisionId),
    }).unwrap();

    if (!url.signedUrl) {
      return;
    }
    downloadFileFromUrl(
      url.signedUrl,
      'Demo’s text successfully exported to spreadsheet.',
      'Open Spreadsheet'
    );
  };

  return { downloadExtractedText, isCSVEmpty };
};
